export const apiEndpoints = {
  permissions: "/api/v1/permissions/",
  users: {
    suggestions: "/api/v1/users/suggestions",
  },
  departments: {
    suggestions: "/api/v1/departments/suggestions",
  },
};
